import React from 'react';
import axios from 'axios';
import Config from '../config'; 

export default function connectNotifications (Component){
    return class ConnectedNotifications extends React.Component {
      state = {
        notifications: null
      }
  
      async componentDidMount(){

        this._isMounted = true
        const response = await axios.get(Config.API + '/AKVNA872/notifications')
        
        
        if (!this._isMounted) return
        const notifications = response.data
        
        this.setState({ notifications }); 
      }
  
      componentWillUnmount(){
        this._isMounted = false
      }
  
      render(){
        
        const { notifications } = this.state
        if (!notifications) return null
        
        return <Component {...this.props} notifications={notifications} />
      }
    }
}


// WEBPACK FOOTER //
// ./src/connectors/notificationsConnector.js